import React,{useEffect} from 'react'

export const DataTable2=React.memo((props)=>{
  let tableId=`datatableDefault${props.count?props.count:1}`
  let additonalConfig={};
  if(props.deferLoading){
    additonalConfig={deferLoading:0}
  }

  let order=[];
  if(props.order){
order=props.order;
  }
  let markAttendance=function(e){
    var employeeId=window.$(this).data("emloyeeid");
    var id=window.$(this).attr("data-id");
    props.onSelectSubmit(id,employeeId);
   }
   let details=function(e){
    var employeeId=window.$(this).data("emloyeeid");
    var index=window.$(this).attr("data-index");
    props.onDetails(employeeId,index);
   }
   let deleteFun=function(){
    props.parentFun.onDelete(window.$(this).data("id"),window.$(this).data("index"));
    }
   let update=function(){
      props.parentFun.onUpdate(window.$(this).data("id"),window.$(this).data("index"));
    }
   let updateImages=function(){
    props.parentFun.onUpdateImage(window.$(this).data("id"),window.$(this).data("index"));
  }
  let addImages=function(){
    props.parentFun.onAddImage(window.$(this).data("id"),window.$(this).data("index"));
  }
  let numberOfPicsOnBackend=function(){
    props.parentFun.numberOfPicsOnBackend(window.$(this).data("id"));
  }
  
	useEffect(()=>{
   if(!window.$.fn.DataTable.isDataTable('#'+tableId)){
     window.$('#'+tableId).DataTable({
      dom: "<'row mb-3'<'col col-lg-4'l><'col-sm-12 col-lg-8 text-end'<'d-flex data-table-resp justify-content-between'fB>>>t<'d-flex align-items-center'<'me-auto'i><'mb-0'p>>",
          responsive: true,
          buttons: [ 
            { extend: 'print', className: 'btn btn-default' },
            { extend: 'csv', className: 'btn btn-default' }
          ],
		   
        columns: props.headers,
        processing: true,
        serverSide: true,
        order,
        ajax:async(params,callback)=>{
          try{
            await props.ajax(params,callback);
          }catch(e){
          console(e);
          }
         },
         ...additonalConfig
        });
	}

  if(props.onSelectSubmit){
    window.$(document).on("click",".mark-attendance",markAttendance)
   
  }
  if(props.onDetails){
    window.$(document).on("click",".details",details)
  }
  if(props.parentFun){
    window.$(document).on("click",".delete",deleteFun)
    window.$(document).on("click",".update",update)
    window.$(document).on("click",".update_image",updateImages)
    window.$(document).on("click",".add_images",addImages)
  }
  if(props.parentFun?.numberOfPicsOnBackend){
    window.$(document).on("click",".get-images-backend",numberOfPicsOnBackend)
  }
  return ()=>{
    window.$('#'+tableId).DataTable().destroy(true);
    if(props.onSelectSubmit){
    window.$(document).off("click",".mark-attendance",markAttendance)
    }
    if(props.onDetails){
    window.$(document).off("click",".details",details)
    }
    if(props.parentFun){
    window.$(document).off("click",".delete",deleteFun)
    window.$(document).off("click",".update",update)
    window.$(document).off("click",".update_image",updateImages)
    window.$(document).off("click",".add_images",addImages)
    }
    if(props.parentFun?.numberOfPicsOnBackend){
      window.$(document).off("click",".get-images-backend",numberOfPicsOnBackend)
    }
  }
	},[])
  return (
    <>
    <table id={tableId} className="table table-responsive"></table>
    </>
  )
}
)
